document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('.belt-addon-modal');
  if (!modal) return;

  const dialog = modal.querySelector('.belt-addon-modal__dialog');
  const addToCartButton = document.querySelector('[id^="ProductSubmitButton-"]');
  if (!addToCartButton) return;

  let productForm = addToCartButton.closest('form');
  if (!productForm) {
    productForm = document.querySelector('form[action*="/cart/add"]');
  }
  if (!productForm) return;

  const closeButtons = modal.querySelectorAll('[data-belt-close]');
  const skipButton = modal.querySelector('[data-belt-skip]');
  const confirmButton = modal.querySelector('[data-belt-confirm]');

  let hiddenFloatingElements = [];

  function getProductVariantId() {
    const variantInput =
      productForm.querySelector('input[name="id"]') ||
      productForm.querySelector('select[name="id"]');

    return variantInput ? variantInput.value : null;
  }

  function getQuantity() {
    const qtyInput = productForm.querySelector('input[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function getSelectedBeltVariantId() {
    const checked = modal.querySelector('input[name^="belt-addon-choice-"]:checked');
    if (!checked) return null;
    return checked.value ? checked.value : null;
  }

  function hideMobileFloatingBars() {
    hiddenFloatingElements = [];

    if (window.innerWidth > 699) return;

    const allElements = Array.from(document.body.querySelectorAll('*'));

    allElements.forEach(function (el) {
      if (!el || modal.contains(el)) return;
      if (el === modal) return;

      const style = window.getComputedStyle(el);
      const rect = el.getBoundingClientRect();

      const isFixedOrSticky =
        style.position === 'fixed' || style.position === 'sticky';

      const nearBottom =
        rect.bottom > window.innerHeight - 140 &&
        rect.top < window.innerHeight;

      const likelyToolbarHeight =
        rect.height > 20 && rect.height < 140;

      const wideEnough =
        rect.width > window.innerWidth * 0.45;

      if (isFixedOrSticky && nearBottom && likelyToolbarHeight && wideEnough) {
        hiddenFloatingElements.push({
          element: el,
          display: el.style.display,
          visibility: el.style.visibility,
          opacity: el.style.opacity,
          pointerEvents: el.style.pointerEvents
        });

        el.style.display = 'none';
        el.style.visibility = 'hidden';
        el.style.opacity = '0';
        el.style.pointerEvents = 'none';
      }
    });
  }

  function restoreMobileFloatingBars() {
    hiddenFloatingElements.forEach(function (item) {
      item.element.style.display = item.display || '';
      item.element.style.visibility = item.visibility || '';
      item.element.style.opacity = item.opacity || '';
      item.element.style.pointerEvents = item.pointerEvents || '';
    });

    hiddenFloatingElements = [];
  }

  function openModal() {
    modal.hidden = false;
    document.body.classList.add('belt-addon-modal-open');
    hideMobileFloatingBars();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('belt-addon-modal-open');
    restoreMobileFloatingBars();
  }

  async function addItemsToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Cart add failed');
    }

    return response.json();
  }
  function showAddToCartToast(message) {
  const existingToast = document.querySelector('.belt-addon-toast');
  if (existingToast) existingToast.remove();

  const toast = document.createElement('div');
  toast.className = 'belt-addon-toast';
  toast.textContent = message;

  Object.assign(toast.style, {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: '99999',
    background: '#3B0510',
    color: '#ffffff',
    padding: '12px 16px',
    borderRadius: '10px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    fontSize: '14px',
    lineHeight: '1.4',
    opacity: '0',
    transform: 'translateY(10px)',
    transition: 'opacity 0.25s ease, transform 0.25s ease'
  });

  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(10px)';
    setTimeout(() => toast.remove(), 250);
  }, 3000);
}
  async function handleAdd(withBelt) {
    const productVariantId = getProductVariantId();
    const quantity = getQuantity();

    if (!productVariantId) {
      alert('Productvariant niet gevonden.');
      return;
    }

    const items = [
      {
        id: Number(productVariantId),
        quantity: quantity
      }
    ];

    if (withBelt) {
      const beltVariantId = getSelectedBeltVariantId();

      if (beltVariantId) {
        items.push({
          id: Number(beltVariantId),
          quantity: quantity
        });
      }
    }

    try {
      if (skipButton) skipButton.disabled = true;
      if (confirmButton) confirmButton.disabled = true;

      await addItemsToCart(items);

      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

if (typeof updateHeaderCartCount === 'function') {
  updateHeaderCartCount(cart);
}

closeModal();
showAddToCartToast(withBelt ? 'Jurk en riem toegevoegd aan je winkelwagen' : 'Product toegevoegd aan je winkelwagen');
      closeModal();
    } catch (error) {
      console.error('Belt add-on error:', error);
      alert('Er ging iets mis bij het toevoegen aan de winkelwagen. Probeer het opnieuw.');
    } finally {
      if (skipButton) skipButton.disabled = false;
      if (confirmButton) confirmButton.disabled = false;
    }
  }

  addToCartButton.addEventListener(
    'click',
    function (event) {
      event.preventDefault();
      event.stopPropagation();
      openModal();
    },
    true
  );

  if (dialog) {
    dialog.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      closeModal();
    });
  });

  if (skipButton) {
    skipButton.addEventListener('click', function () {
      handleAdd(false);
    });
  }

  if (confirmButton) {
    confirmButton.addEventListener('click', function () {
      handleAdd(true);
    });
  }

  window.addEventListener('resize', function () {
    if (modal.hidden) return;
    restoreMobileFloatingBars();
    hideMobileFloatingBars();
  });
});